/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getProfileRank } from '../fn/profile-analytics/get-profile-rank';
import { GetProfileRank$Params } from '../fn/profile-analytics/get-profile-rank';
import { ProfileAnalyticsFollowersListResponse } from '../models/profile-analytics-followers-list-response';
import { ProfileAnalyticsHistogram } from '../models/profile-analytics-histogram';
import { profileFollowerList } from '../fn/profile-analytics/profile-follower-list';
import { ProfileFollowerList$Params } from '../fn/profile-analytics/profile-follower-list';

@Injectable({ providedIn: 'root' })
export class ProfileAnalyticsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getProfileRank()` */
  static readonly GetProfileRankPath = '/rest/profile/{id}/analytics/rank';

  /**
   * Get rank analytics for profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileRank()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileRank$Response(params: GetProfileRank$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsHistogram>> {
    return getProfileRank(this.http, this.rootUrl, params, context);
  }

  /**
   * Get rank analytics for profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfileRank$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileRank(params: GetProfileRank$Params, context?: HttpContext): Observable<ProfileAnalyticsHistogram> {
    return this.getProfileRank$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsHistogram>): ProfileAnalyticsHistogram => r.body)
    );
  }

  /** Path part for operation `profileFollowerList()` */
  static readonly ProfileFollowerListPath = '/rest/profile/{id}/analytics/followers/list/{offset}/{limit}';

  /**
   * Get list profile followers (with pagination).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileFollowerList()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileFollowerList$Response(params: ProfileFollowerList$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsFollowersListResponse>> {
    return profileFollowerList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list profile followers (with pagination).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileFollowerList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileFollowerList(params: ProfileFollowerList$Params, context?: HttpContext): Observable<ProfileAnalyticsFollowersListResponse> {
    return this.profileFollowerList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsFollowersListResponse>): ProfileAnalyticsFollowersListResponse => r.body)
    );
  }

}
